import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-446455aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-wrapper" }
const _hoisted_2 = { class: "chat" }
const _hoisted_3 = { class: "chat-name" }
const _hoisted_4 = { class: "message-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "call-message-preview"
}
const _hoisted_6 = { class: "ongoingCall" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 3,
  class: "call-message-preview"
}
const _hoisted_10 = { key: 4 }
const _hoisted_11 = { class: "information" }
const _hoisted_12 = { class: "date" }

import ProfileImage from "@/components/images/ProfileImage.vue";
import { GetterTypes } from "@/store";
import { convertDateToStringDate } from "@/utils/date";
import {
  AudioMessage,
  CallMessage,
  Chat,
  FriendRequestMessage,
  Message,
  TextMessage,
} from "@/store/chats/types";
import { useComputedValue } from "@/composables/useComputedValue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { getFullChatName, getIsChatPreviewVisible } from "@/utils/chat";
import { useRouter } from "vue-router";
import {
  getIsMessageTextType,
  getIsMessageCallType,
  getCallStatusProperties,
  getIsMessageHidden,
  getIsMessageAudioType,
  getIsMessageFriendRequestType,
} from "@/utils/message";
import { IconType } from "@/types/icons";
import Icon from "@/components/icons/Icon/Icon.vue";
import { AppEnvironment } from "@/store/app/state";

interface Props {
  chat: Chat;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatPreview',
  props: {
    chat: {}
  },
  setup(__props: any) {

const props = __props;
const { t } = useI18n();
const authId = useComputedValue<number>(GetterTypes.GET_AUTH_ID);
const selectedChatId = useComputedValue<string>(
  GetterTypes.GET_SELECTED_CHAT_ID,
);
const router = useRouter();
const isChatSelected = computed<boolean>(
  () => selectedChatId.value === props.chat.id,
);
const latestMessage = computed(() => props.chat.latestMessage);
const isOngoingCall = computed(() => {
  return !!props.chat.activeCall;
});
const environment = useComputedValue<AppEnvironment>(
  GetterTypes.GET_APP_ENVIRONMENT,
);

const getIsTextMessage = (
  message: Message | undefined,
): message is TextMessage => {
  if (!message) return false;
  return getIsMessageTextType(message);
};

const getIsCallMessage = (
  message: Message | undefined,
): message is CallMessage => {
  if (!message) return false;
  return getIsMessageCallType(message);
};

const getIsAutomaticMessage = (
  message: Message | undefined,
): message is CallMessage | FriendRequestMessage => {
  if (!message) return false;
  return (
    getIsMessageCallType(message) || getIsMessageFriendRequestType(message)
  );
};

const getIsAudioMessage = (
  message: Message | undefined,
): message is AudioMessage => {
  if (!message) return false;
  return getIsMessageAudioType(message);
};

const chatMessage = computed(() => {
  const lastMessageValue = latestMessage.value;
  if (!lastMessageValue || !getIsMessageTextType(lastMessageValue)) {
    return "";
  }
  const { messageText, attachments } = lastMessageValue;

  const isEmpty = getIsMessageHidden(messageText, attachments);

  if ((lastMessageValue?.hidden && !isEmpty) || lastMessageValue?.isDeleted) {
    return t("chat.chatSidebar.ChatPreview.removeMessageLabel");
  }
  if (getIsTextMessage(lastMessageValue)) {
    return lastMessageValue?.displayMessageText;
  }
  return "";
});

const isOutgoing = computed(() => {
  if (!latestMessage.value) return false;
  return authId.value === latestMessage.value.senderId;
});

const statusProperties = computed(() => {
  if (!getIsCallMessage(latestMessage.value)) return;
  return getCallStatusProperties({
    isOutgoing: isOutgoing.value,
    isPreview: true,
    status: latestMessage.value.status,
    duration: latestMessage.value.duration,
  });
});

const isPreviewVisible = computed<boolean>(() => {
  return getIsChatPreviewVisible(props.chat);
});

const openChat = () => {
  const chatId = props.chat.id;
  router.push(`/${chatId}`);
};
const getMessageStringDate = () => {
  let date = props.chat.latestMessage?.sentAt || props.chat?.createdAt;
  if (!date) {
    return "";
  }
  return convertDateToStringDate(date, t);
};

const appliedChatName = computed<string>(() => {
  return getFullChatName(props.chat);
});

return (_ctx: any,_cache: any) => {
  return (isPreviewVisible.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["chat-preview", {
      selected: isChatSelected.value,
      notStandalone: !_unref(environment).isMobileApp,
    }]),
        onClick: openChat
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(ProfileImage, {
            id: _ctx.chat.id,
            image: props.chat.picture,
            type: props.chat.type,
            size: 54,
            "disable-redirect": true
          }, null, 8, ["id", "image", "type"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString(appliedChatName.value), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (
            !getIsAutomaticMessage(latestMessage.value) && latestMessage.value?.statusIcon
          )
              ? (_openBlock(), _createBlock(Icon, {
                  key: 0,
                  icon: latestMessage.value.statusIcon,
                  class: "seen-icon"
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["message", {
            notRead: getIsTextMessage(latestMessage.value) && !latestMessage.value?.read,
          }])
            }, [
              (isOngoingCall.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(Icon, {
                      icon: _unref(IconType).ONGOING_CALL_PREVIEW,
                      class: "arrow"
                    }, null, 8, ["icon"]),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)("call.status.ongoing")), 1)
                  ]))
                : (getIsTextMessage(latestMessage.value))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(chatMessage.value), 1))
                  : (getIsAudioMessage(latestMessage.value))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(latestMessage.value.isDeleted
                ? _unref(t)("chat.chatSidebar.ChatPreview.removeMessageLabel")
                : _unref(t)("chat.chatContainer.messages.audioMessage")), 1))
                    : (getIsCallMessage(latestMessage.value) && statusProperties.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(Icon, {
                            icon: statusProperties.value.arrowIcon,
                            class: "arrow"
                          }, null, 8, ["icon"]),
                          _createElementVNode("span", {
                            class: _normalizeClass(["message-text", [{ incoming: !isOutgoing.value }, latestMessage.value.status]])
                          }, _toDisplayString(_unref(t)(statusProperties.value.text) + statusProperties.value.duration), 3)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(t)("chat.chatContainer.messages.friendRequest.request")), 1))
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(getMessageStringDate()), 1)
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})